// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card.card-profile {
  z-index: 5;
}

.section-profile-cover {
  height: 470px;
}

@media (max-width: 991.98px) {
  .section-profile-cover {
    height: 300px;
  }
}
.headings {
  border-radius: 5px;
  background-color: #593faa;
  color: #fff;
  padding: 1rem 0;
}

.badge-secondary {
  color: #fff;
  background-color: #6449b3;
}

td.info-cell {
  display: flex;
  justify-content: center;
}

.check-icon {
  color: green;
}

.error-icon {
  color: #f44336;
}

.map-card {
  border-bottom: solid 2px #3f51b5;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}`, "",{"version":3,"sources":["webpack://./src/app/nonAdmin/profile/profile.component.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI;IACI,aAAA;EACN;AACF;AAEA;EAEI,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;AADJ;;AAIA;EACI,WAAA;EACA,yBAAA;AADJ;;AAIA;EACI,aAAA;EACA,uBAAA;AADJ;;AAIA;EACI,YAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,gCAAA;EACA,8BAAA;EACA,+BAAA;AADJ","sourcesContent":[".card.card-profile {\r\n    z-index: 5;\r\n}\r\n\r\n.section-profile-cover {\r\n    height: 470px;\r\n}\r\n\r\n@media (max-width: 991.98px) {\r\n    .section-profile-cover {\r\n        height: 300px;\r\n    }\r\n}\r\n\r\n.headings {\r\n    // background-color: #fff3cd;\r\n    border-radius: 5px;\r\n    background-color: #593faa;\r\n    color: #fff;\r\n    padding: 1rem 0;\r\n}\r\n\r\n.badge-secondary {\r\n    color: #fff;\r\n    background-color: #6449b3;\r\n}\r\n\r\ntd.info-cell {\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.check-icon {\r\n    color: green\r\n}\r\n\r\n.error-icon {\r\n    color: #f44336;\r\n}\r\n\r\n.map-card{\r\n    border-bottom: solid 2px #3f51b5;\r\n    border-bottom-left-radius: 3px;\r\n    border-bottom-right-radius: 3px\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
